import isNil from 'lodash/isNil';

const areIndexesWithinRange = (indexes: number[], size: number): boolean => indexes.every(
  (index) => index >= 0 && index <= size - 1,
);

export function insert(array: any[], item: any, index?: number) {
  const _index = isNil(index) ? array.length : index;
  return [
    ...array.slice(0, _index),
    item,
    ...array.slice(_index),
  ];
}

export function remove(array: any[], index: number) {
  return areIndexesWithinRange([index], array.length)
    ? [
      ...array.slice(0, index),
      ...array.slice(index + 1),
    ]
    : array;
}

export function reorder(array: any[], currentIndex: number, newIndex: number): any[] {
  return (
    array.length === 0
    || !areIndexesWithinRange([currentIndex, newIndex], array.length)
  )
    ? array
    : insert(remove(array, currentIndex), array[currentIndex], newIndex);
}
